import { store } from 'app_storage/redux-storage'
import parse from 'html-react-parser'
import React, { CSSProperties, useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { Store } from 'redux'

import '../questionOpenAnswer.scss'

// import NextQuestionButtonComponent from 'app_components/commons/nextQuestionButton/containers/nextQuestionButtonComponent'

//@Import actions
// import { updateQuestionState } from 'app_events/resource/exercise/actions'
import InputFieldEditorComponent from 'app_components/screens/editor/components/inputFieldEditorComponent/inputFieldEditorComponent'
import TinyEditorComponent from 'app_components/commons/tinyEditor'
//@end
interface IQuestionOpenAnswerLayoutProps {
  questionData: any
  defaultAnswer: string | null
  className?: string
  style?: CSSProperties
  hideButtons?: boolean
  disabled?: boolean
  showCorrect?: boolean
  showMyResponse?: boolean
  validateMyResponse?: boolean
  showFeedback?: boolean
  onNextQuestion: (data: any) => void
  handleSendOnChange: (text: string) => any
}

const QuestionOpenAnswerLayout: React.FC<IQuestionOpenAnswerLayoutProps> = (props) => {
  const storeObject: Store = store
  const [textStatus, setTextStatus] = useState<string>(props.defaultAnswer ? props.defaultAnswer : '')
  const { t } = useTranslation()
  const form = useForm()

  useEffect(() => {
    if (props.defaultAnswer) {
      setTextStatus(props.defaultAnswer)
    }
  }, [props.defaultAnswer])

  useEffect(() => {
    // storeObject.dispatch(updateQuestionState({
    //   questionData: props.questionData,
    //   answer: textStatus,
    //   type: 'openAnswer',
    // }))
    // @INFO Enviar el evento on change
    props.handleSendOnChange(textStatus)
  }, [textStatus])

  useEffect(() => {
    const newText = props.defaultAnswer ? props.defaultAnswer : ''
    setTextStatus(newText)
    // storeObject.dispatch(updateQuestionState({
    //   questionData: props.questionData,
    //   answer: newText,
    //   type: 'openAnswer',
    // }))
  }, [props.questionData._id])

  useEffect(() => {
    return () => {
      // storeObject.dispatch(updateQuestionState({}))
    }
  }, [])

  const handleChange = (event: any) => {
    let { value, min, max }: any = event.target
    value = Math.max(Number(min), Math.min(Number(max), Number(value)))

    setTextStatus(value)
  }

  const openQuestionText = () => {
    return (
      <textarea
        name='answer'
        onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => setTextStatus(e.currentTarget.value)}
        id={props.questionData._id}
        ref={form.register({ required: false, min: props?.questionData?.config?.min_length, max: props?.questionData?.config?.max_length })}
        value={textStatus}
        minLength={props.questionData.config.min_length}
        maxLength={props.questionData.config.max_length}
        disabled={props.disabled}
      >
      </textarea>
    )
  }

  const openQuestionDate = () => {
    return (
      <input
        name='answer'
        type='date'
        id={props.questionData._id}
        ref={form.register({ required: false })}
        onChange={(e: any) => setTextStatus(e.currentTarget.value)}
        value={textStatus}
        disabled={props.disabled}
      />
    )
  }

  const openQuestionNumber = () => {
    return (
      <input
        name='answer'
        type='number'
        min={props?.questionData?.config?.min_length}
        max={props?.questionData?.config?.max_length}
        onChange={(e: any) => handleChange(e)}
        id={props.questionData._id}
        ref={form.register({ required: false, min: props?.questionData?.config?.min_length, max: props?.questionData?.config?.max_length })}
        value={textStatus}
        disabled={props.disabled}
      />
    )
  }

  const openQuestionInput = () => {
    return (
      <InputFieldEditorComponent
        type='text'
        name='answer'
        min={props?.questionData?.config?.min_length}
        max={props?.questionData?.config?.max_length}
        onChange={(e) => setTextStatus(e.target.value)}
        id={props.questionData._id}
        ref={form.register({ required: false, min: props?.questionData?.config?.min_length, max: props?.questionData?.config?.max_length })}
        value={textStatus}
        disabled={props.disabled}
      />
    )
  }

  const openQuestionTiny = () => {
    return(
      <TinyEditorComponent
        data={textStatus}
        onChange={(data) => setTextStatus(data)}
        editState={!props.disabled}
      />
    )
  }

  const getComponentFromType = (type: string) => {
    switch (type) {
      case 'text':
        return openQuestionText()
      case 'number':
        return openQuestionNumber()
      case 'date':
        return openQuestionDate()
      case 'tiny':
        return openQuestionTiny()
      case 'input':
        return openQuestionInput()
      default:
        return openQuestionText()
    }
  }

  return (
    <div
      className={`question_open_answer-component ${props.className}`}
      style={props.style}
    >
      {/* <div className='content'>{parse(props.questionData.content)}</div> */}
      <div className='answer-container'>
        <div className='answer'>
          <form onSubmit={form.handleSubmit((data) => props.onNextQuestion(data))}>
            {getComponentFromType(props?.questionData?.config?.type_input)}
            {/* {!props.hideButtons ?
              <NextQuestionButtonComponent />
            :null} */}
          </form>
        </div>
      </div>
    </div>
  )
}

export default QuestionOpenAnswerLayout
